module.exports = __webpack_public_path__ + "img/nav-ponds.caa40887.svg";